export const APPLICATION_INITIALIZED = "APPLICATION_INITIALIZED";
export const APPLICATION_LOADING = "APPLICATION_LOADING";
export const APPLICATION_STOP_LOADING = "APPLICATION_STOP_LOADING";
export const ENABLE_MAINTENANCE_MODE = "ENABLE_MAINTENANCE_MODE";
export const DISABLE_MAINTENANCE_MODE = "DISABLE_MAINTENANCE_MODE";
